const CustomerCategory = {

    // FIELDS
    "name": "الاسم",
    "description": "الوصف",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "customer_category": "فئة العميل",

    // ERROR
    "error_name": "ادخل الاسم",
    "error_desc": "ادخل الوصف",
    "error_status": "اختر الحالة",

    // TABLE HEADER
    "table_name": 'الاسم',
    "table_description": "الوصف",
    "table_status": "الحالة",
}

export default CustomerCategory;